var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-list-item', {
    on: {
      "click": function click($event) {
        _vm.$s[_vm.configName] = !_vm.$s[_vm.configName];
      }
    }
  }, [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(_vm.title))]), _vm.subtitle ? _c('v-list-item-subtitle', [_vm._v(_vm._s(_vm.subtitle))]) : _vm._e()], 1), _c('v-list-item-action', [_c('v-switch', {
    attrs: {
      "color": "primary",
      "readonly": ""
    },
    model: {
      value: _vm.$s[_vm.configName],
      callback: function callback($$v) {
        _vm.$set(_vm.$s, _vm.configName, $$v);
      },
      expression: "$s[configName]"
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }